// Entry point for the build script in your package.json
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'
import ServicePage from './components/ServicePage'

document.addEventListener('DOMContentLoaded', () => {
  // Main app (home page)
  const rootElement = document.getElementById('react-root')
  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(<App />)
  }

  // Service pages
  const servicePageElement = document.getElementById('service-page-root')
  if (servicePageElement) {
    const service = servicePageElement.dataset.service
    const projects = servicePageElement.dataset.projects
    const root = createRoot(servicePageElement)
    root.render(<ServicePage service={service} projects={projects} />)
  }
})
